import { useQuery } from 'react-query'
import type { AxiosInstance } from 'axios'
import { queryKeys, routes } from './constants'
import { axiosInstance } from './axiosConfig'

export interface OptOutInfo {
  physicianId: string
  physicianName: string
  email: string
}

const getOptOutInfo = async (
  physicianId: string,
  instance: AxiosInstance
): Promise<OptOutInfo> => {
  const { data } = await instance.get<OptOutInfo>(routes.physicianOptOut(physicianId))
  return data
}

export interface useOptOutInfoProps {
  physicianId?: string
  axios?: AxiosInstance
}

export const useOptOutInfo = ({ physicianId, axios = axiosInstance }: useOptOutInfoProps) => {
  const { data, isLoading, isError, error } = useQuery(
    queryKeys.optOutInfo(physicianId ?? ''),
    () => getOptOutInfo(physicianId as string, axios),
    {
      enabled: !!physicianId,
      retry: false,
    }
  )

  return {
    optOutInfo: data,
    isLoading,
    isError,
    error,
  }
}
